import { defineMessages } from "react-intl";

const messages = defineMessages({
    acceptPrivacyPolicy: {
        description: "Label for accepting privacy policy",
        defaultMessage: "Accept our {link}"
    },
    acceptPrivacyPolicyAriaLabel: {
        description: "Aria label for accept privacy policy checkbox",
        defaultMessage: "Accept privacy policy"
    }
});

export default messages;
